<script setup lang="ts">
import { useUserRole } from "~/composables/useUserRole";

useMarketingOffHomeHashRedirect();

const user = useSupabaseUser();
const { syncSession } = useShowAppMenu();
const { clearProfile, fetchProfile } = useUserRole();

watch(
  user,
  (signedInUser, previousUser) => {
    if (!signedInUser) {
      clearProfile();
      return;
    }
    if (previousUser?.id && signedInUser.id !== previousUser.id) {
      clearProfile();
    }
    void fetchProfile();
  },
  { immediate: true },
);

onMounted(() => {
  void syncSession();
});
</script>

<template>
  <AppIonicShell />
  <AppCmsSaveToast />
</template>
